import { OrganizationSigntureInformation } from "./OrganizationModel";

export interface UserCreate {
  id?: string;
  name?: string;
  login?: string;
  organization?: UserOrganization;
  loginType?: number;
  groups?: string[];
  twoFaAuthEnabled?: boolean;
  phone?: string;
}

export interface UserOrganization {
  idOrganization: string;
  isAdminOrganization: boolean;
}

export interface UserGet {
  id?: string;
  name?: string;
  login?: string;
  groups?: string[];
  organizations?: UserOrganizationVORetrieve[];
  adminSystem: boolean;
  loginType: number;
  twoFaAuthEnabled?: boolean;
  phone?: string;
  picture?: string;
}

export interface UserOrganizationVORetrieve {
  idOrganization: string;
  internalName: string;
  isAdminOrganization: boolean;
}

export interface UserDelete {
  id?: string;
  organizationName?: string;
}

export enum KeydrivePlan {
  ESSENCIAL = 0,
  PROFISSIONAL,
  SCALE,
  FREE,
  PERSONAL
}

export interface AddingUserGuestVO {
  email: string;
}

export enum EnumSignture {
  Free = 0,
  Premium = 1,
  Canceled = 2,
  Hold = 3,
  PaymentFailedOneAlert,
  PaymentFailedOneWarning,
  PaymentFailedOneCritical,
}

export interface IUserMigrationWaitingVO {
  userId: string;
  username: string;
  login: string;
  signture: EnumSignture;
  signtureId: string;
}

export interface IUserSignture {
  signture: number;
  signtureId: string;
  isOriginSignture: boolean;
  plans: KeydrivePlan[];
  cancelAt: string;
}

export interface UserProfile {
  id?: string;
  name?: string;
  login?: string;
  groups?: string[];
  adminSystem?: boolean;
  preferences?: Preferences;
  organizations?: OrgPreferences[];
  picture?: string;
  phone?: string;
  signture?: IUserSignture;
  firstOrganizationSaved?: string;
}

export interface Preferences {
  theme?: string;
  language?: string;
}

export interface OrgPreferences {
  id?: string;
  name?: string;
  internalName?: string;
  isUser?: boolean;
  isAdmin?: boolean;
  isAdminOrganization?: boolean;
  isOnlyRead?: boolean;
  isAdminWorkspace?: boolean;
}

export interface IContextProfile extends UserProfile {
  create: (token: string | undefined) => Promise<void>;
  remove: () => void;
  userPicture: string;
  setUserPicture: (set: string) => void;
  userPhone: string;
  setUserphone: (set: string) => void;
  username: string;
  setUsername: (set: string) => void;
  setHavePersonalDataModification: (set: boolean) => void;
  havePersonalDataModification: boolean;
  update: () => void;
  setSigntureInformation: (set: OrganizationSigntureInformation | undefined) => void;
  signtureInformation: OrganizationSigntureInformation | undefined;
}

export interface UserLazy {
  id?: string;
  name?: string;
  login?: boolean;
  deleted?: boolean;
}

export interface UserGroupsVO {
  userId?: string;
  groupId?: string;
}

export interface IUserPermissionObject {
  isSubFolder: boolean;
  permissions: UserPermission[];
}

export interface UserPermission {
  userId: string;
  userName: string;
  isAdminOrganization:boolean,
  isReaderOrganization:boolean,
  permissionType: number;
  login: string;
  phone: string;
  picture: string;
}

export interface UserTwoFaCode {
  userTwoFaCode: string;
}

export interface PasswordReset {
  login: string;
  captchaToken: string;
}

export interface IResetPasswordLogged {
  userLoggedEmail: string;
  login: string;
}

export interface UserLogged {
  orgName: string
}

export interface MfaAuthVO {
  name: string;
  login: string;
  key: string;
  isOtpSetted: boolean;
}

export interface MicrosoftUserAccess {
  access_token: string;
  email: string;
}

export interface PreferencesLists {
  workspacesVOs: QuickAccessWorkspace[];
}

export interface IUserPrivilegeVO {
  id: string;
  name: string;
  email: string;
  permission: number;
  userImage: string;
}

export interface QuickAccessWorkspace {
  id: string;
  name: string;
  isFavorited: boolean;
}

export interface UserMinimal {
  id: string;
  name: string;
  email: string;
}

export interface IAcceptDeviceVO {
  email: string;
  deviceToken: string;
}